export const Account = {
    passwordLabel: 'password',
    signUpLabel: 'sign_up',
    signUpTabTitle: 'sign_up_tab_title',
    signUpTitle: 'sign_up_title',
    termsAndConditionsLabel: 'terms_and_conditions',
    emailSubscriptionLabel: 'email_subscription',
    emailSubscriptionDisclaimer: 'email_subscription_disclaimer',
    existingAccountLabel: 'existing_account',
    signInLabel: 'sign_in',
    signInTabTitle: 'sign_in_tab_title',
    signInTitle: 'sign_in_title',
    signOutLabel: 'sign_out',
    continueAsGuestLabel: 'continue_as_guest',
    guestSignInGdprText: 'guest_sign_in_gdpr',
    addToFavoritesLabel: 'add_to_favorites',
    addedToFavoritesLabel: 'added_to_favorites',
    replenishmentLabel: 'replenishment',
    oneTimeOrderLabel: 'one_time_order',
    autoReplenishLabel: 'auto_replenish',
    signInSignUpTitleLabel: 'sign_in_sign_up',
    showPasswordLabel: 'show_password',
    forgotPasswordLinkAction: 'forgot_password_link_action',
    forgotPasswordLabel: 'forgot_password',
    forgotPasswordActionLabel: 'forgot_password_action',
    passwordLengthRequirementLabel: 'password_length_requirement',
    passwordLowerCharacterLabel: 'password_lower_character',
    passwordUpperCharacterLabel: 'password_upper_character',
    passwordSpecialCharacterLabel: 'password_special_character',
    passwordStrength: 'password_strength',
    forgotPasswordTitle: 'forgot_password_title',
    forgotPasswordSubtitle: 'forgot_password_subtitle',
    backToSignInLabel: 'back_to_sign_in',
    backToSiteLabel: 'back_to_site',
    forgotPasswordResetTitle: 'reset_password_title',
    forgotPasswordResetDescription: 'forgot_password_reset_description',
    forgotPasswordResetCheckEmail: 'forgot_password_reset_check_email',
    resetPasswordTitle: 'reset_password_title',
    resetPasswordSubtitle: 'reset_password_subtitle',
    resetPasswordEmailAddress: 'email_address',
    resetPasswordNewPasswordLabel: 'reset_password_new_password',
    resetPasswordRetypePasswordLabel: 'retype_password',
    resetPasswordActionLabel: 'reset_password_action',
    resetPasswordAgainLabel: 'reset_password_again',
    verifyEmailTitle: 'verify_your_email',
    confirmEmailLinkExpiredLabel: 'confirm_email_link_expired',
    expiredLinkCustomerServiceTitle: 'customer_service',
    expiredLinkCustomerServiceMessage: 'expired_link_customer_service_message',
    sessionExpiredTitle: 'session_expired_title',
    sessionExpiredDescription: 'session_expired_description',
    chooseAnotherDefaultAddressTitle: 'choose_another_default_address',
    confirmNewDefaultAddressTitle: 'confirm_new_default_address',
    setDefaultAddressLabel: 'set_default_address',
    forgotPasswordGDPRText: 'forgot_password_gdpr',
    emailConfirmedLabel: 'email_confirmed',
    confirmEmailAddressLabel: 'confirm_email_address',
    confirmEmailForFullAccessLabel: 'confirm_email_for_full_access',
    emailNotConfirmedLabel: 'needs_confirmation',
    changeEmailTitle: 'change_email',
    currentEmailLabel: 'current_email',
    retypeNewEmailLabel: 'retype_new_email',
    newEmailLabel: 'choose_new_email',
    changeEmailDisclaimerLabel: 'change_email_disclaimer',
    validEmailLabel: 'valid_email',
    chooseNewEmailLabel: 'choose_new_email',
    confirmEmailLabel: 'confirm_email',
    resendConfirmationLabel: 'resend_confirmation',
    currentPasswordLabel: 'current_password',
    emailChangedConfirmationLabel: 'email_change_confirmation',
    pleaseCheckYourInboxLabel: 'check_your_inbox',
    emailConfirmationTitle: 'email_confirmation',
    changePasswordTitle: 'change_password',
    newPasswordLabel: 'new_password',
    retypePasswordLabel: 'retype_password',
    passwordChangedConfirmationLabel: 'password_changed_confirmation',
    passwordChangedLabel: 'password_changed',
    firstLineAddressLabel: 'first_line_address',
    secondLineAddressLabel: 'second_line_address',
    countryLabel: 'country',
    zipCodeLabel: 'zip_code',
    cityLabel: 'city',
    stateLabel: 'state',
    mobileNumberLabel: 'mobile_number',
    defaultAddressLabel: 'default_address',
    companyNameLabel: 'company_name',
    nipLabel: 'nip',
    addNewAddress: 'add_new_address',
    newAddressLabel: 'new_address',
    editAddressTitle: 'edit_address',
    editCheckoutAddressTitle: 'edit_checkout_address',
    deleteAddressTitle: 'delete_address',
    deleteAddressMessage: 'delete_address_message',
    deleteDefaultAddressMessage: 'delete_default_address_message',
    changeImage: 'change_image',
    uploadPhotoInstructions: 'upload_photo_instructions',
    uploadPhotoRecommendations: 'upload_photo_recommendations',
    editProfileTitle: 'edit_profile_title',
    uploadPhotoTitle: 'upload_photo_title',
    accountSettingsTitle: 'account_settings',
    viewUserProfileTitle: 'profile_information',
    viewUserAccountInformationTitle: 'account_information',
    addressBookTitle: 'address_book',
    updateEmailGDPRText: 'update_email_gdpr',
    updateAddressGDPRText: 'update_address_gdpr',
    editUserGDPRText: 'edit_user_gdpr',
    signUpGDPRText: 'sign_up_gdpr',
    privacyPolicyDisclaimerLabel: 'privacy_policy_disclaimer',
    paymentInformation: 'payment_information',
    logoutLabel: 'logout',
    welcomeBack: 'welcome_back',
    continueWithFacebook: 'continue_with_facebook',
    continueWithFacebookPolicy: 'continue_with_facebook_policy',
    continueWithFacebookAdvice: 'continue_with_facebook_advice',
    profileLabel: 'profile',
    settingsLabel: 'settings',
    accountLabel: 'account',
    mandatoryFieldsLabel: 'mandatory_fields',
    maintenanceMessage: 'maintenance_message',
    buyItAgainLabel: 'buy_it_again',
    newToBrand: 'new_to_brand',
    passwordResetInvalidUrlTitle: 'password_reset_invalid_url_title',
    passwordResetInvalidUrlText: 'password_reset_invalid_url_text',
    acceptTermsAndConditionsLabel: 'accept_terms_conditions',
    acceptReceiveNewsletterLabel: 'accept_receive_newsletter',
    acceptLoyaltyTitle: 'accept_loyalty_title',
    acceptLoyaltyLabel: 'accept_loyalty',
    acceptPromotionsLabel: 'accept_promotions',
    acceptLoyaltyDescription: 'accept_loyalty_description',
    optInEmailLabel: 'opt_in_email',
    optInPhoneCallLabel: 'opt_in_phone_call',
    optInSmsLabel: 'opt_in_sms',
    optInDirectMailLabel: 'opt_in_direct_mail',
    optInAllLabel: 'opt_in_all',
    optOutLabel: 'opt_out',
    preferredLanguageLabel: 'preferred_language',
    termsConditionsLoyaltyLabel: 'terms_conditions_loyalty',
    facebookLoginLabel: 'facebook_login',
    signInOnlineAccountLabel: 'sign_in_online_account',
    createNewRecordLabel: 'create_new_record',
    createNewRecordText: 'create_new_record_text',
    signUpText: 'signup_text'
};
